<template>
  <div class="print">
    <!-- head -->
    <div class="print-head">
      <h1>{{ $t('안전보건 조직체계도') }}</h1>
      <div class="stdInfo">
        <div>
          <span >{{ $t('회사명') }}</span>
          <span class="print-input"> {{form.stdInfo.field_name}} </span>
        </div>
        <div>
          <span >{{ $t('작성자') }}</span>
          <span class="print-input"> {{form.stdInfo.writer_name }} </span>
        </div>
        <div>
          <span >{{ $t('작성일') }}</span>
          <span class="print-input"> {{form.stdInfo.date }} </span>
        </div>
      </div>
    </div>

    <!-- body -->
    <div class="print-body">
      <print-node v-for="data of tableData" :value="data"/>
    </div>
  </div>
</template>

<script>

import PrintNode from '@/views/boards/single-page/453/PrintNode.vue'

export default {
  name: "Print",
  components: {
    PrintNode
  },
  props: {
    form: Object,
    board: Object,
  },
  computed: {
    // form 의 data 를 table 에 사용하는 data 로 변환한다.
    tableData () {
      const list = []; //this.form.data
      if (this.form && this.form.organogram && this.form.organogram.data) {
        for (const item of this.form.organogram.data) {
          this.convertTreeToTable(item, 1)
        }
        list.push(...this.form.organogram.data)
      }
      return list
    }
  },
  methods: {
    /**
     * convertTreeToTable: form.data 를 table 에 사용하는 data 로 변환한다.
     */
    convertTreeToTable (item, lv) {
      item.lv = lv
      item.title = this.getTitle(lv)
      item.totalChildCount = this.totalChildCount(item)
      item.paddingLeft = 0;
      item.paddingRight = 0;

      if (item.child && item.child.length > 0) {
        for (const sub of item.child) {
          this.convertTreeToTable(sub, lv + 1)
        }
      }
    },

    totalChildCount (item) {
      if (!item.child || item.child.length === 0) {
        return 1
      } else {
        let count = 0;
        for (const sub of item.child) {
          count += this.totalChildCount(sub)
        }
        return count
      }
    },

    getTitle (lv) {
      const organizations = this.form.organogram.organizations;
      for (const item of organizations) {
        if (item.lv === lv) {
          return item.name;
        }
      }
      return ''
    }
  },
};
</script>

<style lang="scss" scoped>
.print-head {
  padding-bottom: 1rem;
  border-bottom: 1px solid #CDCDCD;

  h1 {
    font-weight: bold;
    text-align: center;
    padding: 5rem;
  }
  .stdInfo {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 1rem;
    margin-top: 20px;
    div {
      display: grid;
      grid-template-columns: 114px 1fr;
      align-items: center;
      span {
        margin-right: 10px;
      }
    }
  }
}

.print-body {
  display: flex;
  justify-content: center;

}
</style>
